import ImageViewer from "./ImageViewer"
import Heading2 from "components/Heading/Heading2";
import "./ImageViewer.css"
import "../../styles/styles.css"
import Layout from "../(others)/layout"


const PagePhotos = () => {
  const images = [
    window.location.href.replace("/photos","") + "/photos/1c3.jpg",
    window.location.href.replace("/photos","") + "/photos/Basecroix5.jpg",
    window.location.href.replace("/photos","") + "/photos/Dessustour3.jpg",
    window.location.href.replace("/photos","") + "/photos/Dessustour4.jpg",
    window.location.href.replace("/photos","") + "/photos/Basecroix5.jpg",
    window.location.href.replace("/photos","") + "/photos/DJI_0279.JPG",
    window.location.href.replace("/photos","") + "/photos/DJI_0684.JPG",
    window.location.href.replace("/photos","") + "/photos/Hauteur.jpg",
    window.location.href.replace("/photos","") + "/photos/IMG_20211007_182613.jpg",
    window.location.href.replace("/photos","") + "/photos/IMG_20211007_182800.jpg",
    window.location.href.replace("/photos","") + "/photos/IMG_20211007_185638.jpg",
    window.location.href.replace("/photos","") + "/photos/ScreenShot2022-08-19.jpg",
    window.location.href.replace("/photos","") + "/photos/Statue1.jpg",
    window.location.href.replace("/photos","") + "/photos/Ste-CatherineOuest3.jpg",
    window.location.href.replace("/photos","") + "/photos/Ste-CatherineOuest4.jpg",
    window.location.href.replace("/photos","") + "/photos/stillcover2CommercantsLaurierOuest.jpg",
    window.location.href.replace("/photos","") + "/photos/stillcover4CommercantsLaurierOuest.jpg",
    window.location.href.replace("/photos","") + "/photos/ToitVentredeboeuf2.jpg",
    window.location.href.replace("/photos","") + "/photos/TourEstcoteSUD-EST3.jpg",
    window.location.href.replace("/photos","") + "/photos/VuearriereOuest.jpg",
    window.location.href.replace("/photos","") + "/photos/Grues.jpg",
    window.location.href.replace("/photos","") + "/photos/Immeuble.jpg",
    window.location.href.replace("/photos","") + "/photos/Eglise.jpg",
    window.location.href.replace("/photos","") + "/photos/Statue2.jpg",
    window.location.href.replace("/photos","") + "/photos/Statue3.jpg",
    window.location.href.replace("/photos","") + "/photos/Immeuble2.jpg",
    window.location.href.replace("/photos","") + "/photos/Danse.jpg",
    window.location.href.replace("/photos","") + "/photos/Immeuble3.jpg",
    window.location.href.replace("/photos","") + "/photos/Immeuble4.jpg",
    window.location.href.replace("/photos","") + "/photos/Immeuble5.jpg",
    window.location.href.replace("/photos","") + "/photos/Immeuble6.jpg",
    window.location.href.replace("/photos","") + "/photos/Piscine.jpg",
    window.location.href.replace("/photos","") + "/photos/Mont-Royal.jpg",
    window.location.href.replace("/photos","") + "/photos/Commerce.jpg",
    window.location.href.replace("/photos","") + "/photos/Ville.jpg"
  ];

    return (
      <Layout>
    
            <Heading2 className="center inline-block align-middle text-4xl font-semibold md:text-5xl">Photos</Heading2>
              <div >
                <ImageViewer images={images} /> 
              </div>   
  
      </Layout>
          )
}

export default PagePhotos;